module.exports = __webpack_public_path__ + "img/sprinkle-27.362f86e9.webp";